import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../api-config';

const kpiList = [
  { key: "ATR_14", label: "ATR 14" },
  { key: "ATR_5", label: "ATR 5" },
  { key: "VolAvg_14", label: "Vol. 14d" },
  { key: "VolAvg_5", label: "Vol. 5d" },
  { key: "High_yesterday", label: "Máx. Ayer" },
  { key: "Low_yesterday", label: "Mín. Ayer" },
];

export default function IndicatorsSummary() {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API_URL}/trading-api/historical/indicators/daily_summary`)
      .then(res => setData(res.data))
      .catch(() => setData(null));
  }, []);

  if (!data) {
    return (
      <div className="flex items-center justify-center min-h-[40vh] text-blue-200 text-lg">
        Cargando indicadores...
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center min-h-screen bg-[#101422] py-12 px-4 text-white">
      <div className="w-full max-w-4xl space-y-6">
        <div className="flex justify-between items-center">
          <h2 className="text-2xl font-semibold">Indicadores Diarios</h2>
          <span className="text-xs text-blue-300">Actualizado: hoy</span>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {kpiList.map(({ key, label }) => (
            <div key={key} className="bg-[#1d2335] rounded-lg p-4 flex flex-col items-center text-center">
              <span className="text-sm text-blue-300 mb-1">{label}</span>
              <span className="text-xl font-bold">
                {typeof data[key] === 'number' ? data[key].toFixed(2) : '-'}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
